/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface ExternalSignUpUserDto
 */
export interface ExternalSignUpUserDto {
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof ExternalSignUpUserDto
     */
    interestedInSubscription?: LookupKeyEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalSignUpUserDto
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalSignUpUserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalSignUpUserDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalSignUpUserDto
     */
    fullName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalSignUpUserDto
     */
    agreedTerms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalSignUpUserDto
     */
    agreedMarketing: boolean;
}

export function ExternalSignUpUserDtoFromJSON(json: any): ExternalSignUpUserDto {
    return ExternalSignUpUserDtoFromJSONTyped(json, false);
}

export function ExternalSignUpUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalSignUpUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interestedInSubscription': !exists(json, 'interestedInSubscription') ? undefined : LookupKeyEnumFromJSON(json['interestedInSubscription']),
        'token': json['token'],
        'email': json['email'],
        'password': json['password'],
        'fullName': json['fullName'],
        'agreedTerms': json['agreedTerms'],
        'agreedMarketing': json['agreedMarketing'],
    };
}

export function ExternalSignUpUserDtoToJSON(value?: ExternalSignUpUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interestedInSubscription': LookupKeyEnumToJSON(value.interestedInSubscription),
        'token': value.token,
        'email': value.email,
        'password': value.password,
        'fullName': value.fullName,
        'agreedTerms': value.agreedTerms,
        'agreedMarketing': value.agreedMarketing,
    };
}

